import React from "react";

interface SearchBarProps {
  searchFunction: (searchText: string) => void;
}

export function SearchBar({ searchFunction }: SearchBarProps) {
  const [searchInput, setSearchInput] = React.useState("");

  return (
    <div className="searchBar">
      <input
        className="searchInput"
        type="text"
        placeholder="Search..."
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            searchFunction(searchInput);
          }
        }}
      />
      <button
        className="searchButton"
        onClick={(e) => {
          searchFunction(searchInput);
        }}>
        Search
      </button>
    </div>
  );
}
